export default __webpack_public_path__ + "static/media/p-sauce.ba5dc77a.jpg";